import { createVuetify } from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
// BS Labs icons: `mdi-*` names draw as Phosphor Regular. The MDI webfont above
// stays loaded for the names with no mapping and for checkbox/radio states.
import { phosphorAliases, phosphorMdiSet, installRawMdiClassCss } from '@/icons/vuetifyPhosphorSet';
//DragScroll
import { VueDraggableNext } from 'vue-draggable-next';
import { BLUE_THEME, AQUA_THEME, PURPLE_THEME, GREEN_THEME, CYAN_THEME, ORANGE_THEME } from '@/theme/LightTheme';
import {
    DARK_BLUE_THEME,
    DARK_AQUA_THEME,
    DARK_ORANGE_THEME,
    DARK_PURPLE_THEME,
    DARK_GREEN_THEME,
    DARK_CYAN_THEME
} from '@/theme/DarkTheme';

installRawMdiClassCss();

export default createVuetify({
    components: {
        draggable: VueDraggableNext
    },
    directives,

    icons: {
        defaultSet: 'mdi',
        aliases: phosphorAliases,
        sets: { mdi: phosphorMdiSet }
    },

    theme: {
        defaultTheme: 'BLUE_THEME',
        themes: {
            BLUE_THEME,
            AQUA_THEME,
            PURPLE_THEME,
            GREEN_THEME,
            CYAN_THEME,
            ORANGE_THEME,
            DARK_BLUE_THEME,
            DARK_AQUA_THEME,
            DARK_ORANGE_THEME,
            DARK_PURPLE_THEME,
            DARK_GREEN_THEME,
            DARK_CYAN_THEME
        }
    },
    defaults: {
        // VWindow's `touch` prop defaults to undefined, which leaves Vuetify's
        // swipe-to-navigate ON: a left swipe calls next(), a right swipe prev().
        // In a data-heavy UI that gesture is indistinguishable from dragging a
        // wide table or a scrollable tab strip sideways, so those drags silently
        // switch tabs instead of scrolling. Tabs here are always reachable by
        // clicking, so the gesture only ever costs the user their place.
        VWindow: {
            touch: false
        },
        // Design system v3.3: tab content fades in (260ms) rather than sliding.
        // Class in scss/components/_ds-motion.scss. No carousels use VWindow.
        VWindowItem: {
            transition: 'ds-tab-fade',
            reverseTransition: 'ds-tab-fade'
        },
        VCard: {
            rounded: 'md',
            elevation: 0
        },
        VTextField: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VTextarea: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VSelect: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        // BS Labs Form field: every text input is the same outlined 40px field.
        VAutocomplete: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VCombobox: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VFileInput: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VListItem: {
            minHeight: '45px'
        },
        VTooltip: {
            location: 'top'
        },
        // Design system v3.3 motion: menus drop 4px and fade, modals drop 12px
        // and fade (classes in scss/components/_ds-motion.scss). A dialog that
        // passes its own transition (e.g. dialog-bottom-transition) keeps it.
        VMenu: {
            transition: 'ds-menu-drop'
        },
        VDialog: {
            transition: 'ds-modal-drop'
        },
        // Design system v3.3 toasts: bottom right, 4.2 s, rise in / slide out
        // right (scss/components/_notifications.scss). Call sites no longer
        // pass their own timeout/location; one that does (the persistent
        // notification-permission prompt) keeps it.
        VSnackbar: {
            location: 'bottom left',
            timeout: 5000,
            transition: 'ds-toast'
        }
    }
});
